import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import {fetchGet,fetchPost,toFormData} from '@/api/common.js';
// import BASE_URl from './utils/commonUrl.js'//引用文件
import Vant,{ Lazyload } from 'vant';
import 'vant/lib/index.css';
import './icons'
import 'amfe-flexible'
// import Vconsole from 'vconsole';
// let vConsole = new Vconsole();
// export default vConsole
import ECharts from 'vue-echarts' // 在 webpack 环境下指向 components/ECharts.vue

// // import style (>= Swiper 6.x)
// import 'swiper/swiper-bundle.css'
//复制粘贴
import VueClipboard from 'vue-clipboard2'
 
Vue.component('v-chart', ECharts)
Vue.use(Lazyload);
Vue.use(Vant);
Vue.use(VueClipboard)
Vue.config.productionTip = false
Vue.prototype.$fetchGet = fetchGet;
Vue.prototype.$fetchPost = fetchPost;
Vue.prototype.$toFormData = toFormData;
// Vue.prototype.commonUrl = BASE_URl//挂载到Vue实例上面

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title == undefined?'i致富':to.meta.title
  // if (to.meta.requireAuth) {
  //     let token = Cookies.get('access_token');
  //     let anonymous = Cookies.get('user_name');
  //     if (token) {
  //             next({
  //                 path: '/login',
  //                 query: {
  //                     redirect: to.fullPath
  //                 }
  //             })

  //     }
  // }
  next();
})
